export const WDS_EE_WIDGET_MAP = {};
